import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { ColorPaper } from '@/components/ui/Surface/ColorPaper';
import { CheckIcon, PersonSuitIcon, } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
import { Text } from '@/components/ui/Typography/Body/Text';
import { Head } from '@/components/ui/Typography/Heading/Head';
import { IconTextGroup } from '@/components/ui/Typography/IconText/IconTextGroup';
/**
 * セミナー：「こんな方におすすめ」を表示するコンポーネント
 * @param props
 * @constructor
 */
export const SeminarCliSolveIssue = (props) => {
    const { className, solveIssue } = props;
    return (_jsxs(ColorPaper, Object.assign({ bgColor: 'info', className: clsx('flex flex-col', 'gap-y-12', className) }, { children: [_jsxs(IconTextGroup, { children: [_jsx(PersonSuitIcon, { color: 'info', size: 'sm' }), _jsx(Head, Object.assign({ color: 'link', size: 'xxs' }, { children: "\u3053\u3093\u306A\u65B9\u306B\u304A\u3059\u3059\u3081" }))] }), _jsx("div", Object.assign({ className: clsx('flex flex-col', 'gap-y-4') }, { children: solveIssue.map((text, i) => (_jsxs(IconTextGroup, Object.assign({ align: 'baseline' }, { children: [_jsx(CheckIcon, { className: 'mt', color: 'info', size: 'xs' }), _jsx(Text, Object.assign({ size: 'xs' }, { children: text }))] }), `${text}${i + 1}`))) }))] })));
};
